import { TableColumnRelation } from "../../ui/context/TableContext";
import { GoodsControl } from "../../domain/control/Goods";

export type GoodsControlTableColumns = {
  unityId: string;
  timestamp: string;
  provider: string;
  document: string;
  entry: string;
  actions: string;
};

export const GoodsControlTableSchema: TableColumnRelation<GoodsControlTableColumns> =
  {
    large: {
      breakpoints: ["lg", "xl", "2xl"],
      columns: [
        {
          name: "unityId",
          label: "Unidad",
          weight: 0.2,
        },
        {
          name: "timestamp",
          label: "Añadido en",
          weight: 0.1,
        },
        {
          name: "provider",
          label: "Proveedor",
          weight: 0.3,
        },
        {
          name: "document",
          label: "Documento",
          weight: 0.2,
        },
        {
          name: "entry",
          label: "Ingreso",
          weight: 0.1,
        },
        {
          name: "actions",
          label: "Acciones",
          weight: 0.1,
        },
      ],
    },
  };
